<template>
	<div class="pages">
		<sub-ibox-title>
			<p slot="title">满减活动</p>
		</sub-ibox-title>
		<section class="content">
			<div class="promotion-cont">
				<div class=" w400">
					<z-input title="活动名称" v-model="params.name" isMust=true maxlength="10"></z-input>
				</div>
				<div class="fx m-t-20">
					<div class="w120 fx-shrink m-r-5 m-t-5 fx"><i class="ask">*</i><span class="fx-fill">活动有效期</span></div>
					<div class="fx-shrink">
						<el-date-picker v-model="params.dtime" type="datetimerange" placeholder="选择时间范围">
						</el-date-picker>
					</div>
				</div>
				<div class="fx m-t-20">
					<div class="w120 fx-shrink m-r-5 m-t-5 fx"><i class="ask">*</i><span class="fx-fill">活动规则</span></div>
					<ul style="overflow: hidden;">
						<li class="p-b-10" v-for="(item, index) in params.condition">
							消费满 <input type="number" v-model="params.condition[index].least_cost" class="m-r-5 m-l-5 b-r-5 input-money input"/>元，
							优惠<input type="number" v-model="params.condition[index].reduce_cost" class="m-r-5 m-l-5 b-r-5 input-money input" />元
							<a slot="reference" class="operat-btn" v-if="params.condition.length != 1 & index > 0" @click="handleSetAttr(index)"><i class="icon-del"></i></a>
						</li>
						<a class="z-btn z-btn-primary b-r-3" @click="handleSetAttr(-1)">新增</a>
					</ul>
				</div>
				<div class="fx card-data m-t-20">
					<p class="w120 fx-shrink fx m-r-5"><i class="ask">*</i><span class="fx-fill">适用门店</span></p>
					<div class="fx-fill">
						<el-transfer v-model="shopIdArr" :data="shopArrLists" :titles="['所有门店', '适用门店']" @change="handleChange"></el-transfer>
					</div>
				</div>
			</div>
			<div class="m-t-20 fx">
				<p class="w120 fx-shrink m-r-5"></p>
				<a class="z-btn z-btn-primary b-r-3" @click="handleAddBtn">保存</a>
			</div>
		</section>
	</div>
</template>
<style scoped lang="scss">
	@import "src/assets/css/common.scss";
	.content {
		border-top: none;
	}
	
	.c-g {
		color: $color-7a7a7a;
	}
	
	.promotion-cont {
		.input-money {
			width: px-em(200px);
			border: 1px solid $color-border;
			pediting: px-em(16px) px-em(20px);
		}
	}
	@media only screen and (min-width:0px) and (max-width:640px) {
		.pages{
			min-width: px-em(1000px);
		}
	}
</style>
<script>
	import {
		mapState,
		mapActions
	} from 'vuex'
	export default {
		name: 'PromotionsEditPage',
		components: {},
		data() {
			return {
				params: {
					id: '',
					name: '',
					dtime: [],
					shop_list: [],
					condition: [{
						least_cost: '',
						reduce_cost: ''
					}]
				},
				shopArr: [],//所有完整的门店列表
				shopArrLists: [],//显示在穿梭框左侧的门店列表（左侧门店）
				shopIdArr: [],//显示在穿梭框右侧的门店列表（右侧已选门店）
				shopIds: []
			}
		},
		
		computed: {
			...mapState({
				info: state => state.promotions.detail,
				shopList: state => state.shopManage.shopList.list,
			})
		},
		mounted() {
			this.params.id = this.$route.query.id;
			this.handleGetShopList();
			if(this.$re_Number(this.params.id)) this.handleActiveDetail(this.params.id);
		},
		/*
		 * 事件处理
		 */
		methods: {
			//移动事件
			handleChange(arr) {
				this.params.shop_list = [];
				this.shopIds = [];
				arr.map((item) => {
					this.params.shop_list.push(this.shopArrLists[item].id);
				})
				this.shopIds = this.params.shop_list;
			},
			
			//新增或者减少满减条件
			handleSetAttr(index) {
				if (index == -1) {
					this.params.condition.push({least_cost: '', reduce_cost: ''});
				} else {
					if (this.params.condition.length == 1) return;
					this.params.condition.splice(index, 1);
				}
			},
			
			//获取活动详情
			async handleActiveDetail(entityId) {
				await this.getPromotionDetail({entityId: entityId});
				
				this.params.name = this.info.name;
				this.params.dtime.push(this.info.start_time);
				this.params.dtime.push(this.info.end_time);
				let priceConditionInfo = eval(this.info.condition);
				priceConditionInfo.map((item, index) =>{
					priceConditionInfo[index].least_cost = (item.least_cost / 100).toFixed(2);
					priceConditionInfo[index].reduce_cost = (item.reduce_cost / 100).toFixed(2);
				});
				this.params.condition = priceConditionInfo;
				this.info.shop_list.map((value) => {
					this.shopIds.push(value.id);
				});
				this.shopArr.map((item, index) => {
					if (this.shopIds.indexOf(item.id) > -1) {
						this.shopIdArr.push(index);
						this.params.shop_list.push(this.shopArrLists[index].id);
					}
				})
			},
			
			//保存
			handleAddBtn() {
				if(!this.params.name) return this.$warning('请输入活动名称!');
				if (!this.params.name.length > 10) return this.$warning('活动名称最多为10个字符');
				if(this.params.dtime <= 0) return this.$warning('请选择活动时间!');
				if (this.shopIdArr.length <= 0) return this.$warning('请选择适用门店!');
				this.shopIdArr.map((value) => {
					this.params.shop_list.push(this.shopArrLists[value].id);
				});
				this.$log(this.params);
				this.handleAddPromotion();
			},
			
			//保存
			async handleAddPromotion() {
				try {
					this.params.start_time = this.params.dtime[0];
					this.params.end_time = this.params.dtime[1];
					this.params.shop_list = [];
					this.shopIdArr.map((value) => {
						this.params.shop_list.push(this.shopArr[value].id);
					});
					delete this.params.dtime;
					await this.savePromotion(this.params);
					this.$success('操作成功');
					this.$back();
				} catch (e) {
					this.$errorMsg('操作失败');
				}
			},
			
			//获取门店列表
			async handleGetShopList() {
				await this.getShopList({count: 10000, offset: 0, search: ''});
				this.shopArr = this.shopList;
                this.shopArr.map((item, index) => {
                    this.shopArrLists.push({
                    		key: index,
                    		label: item.name,
                    		id: item.id
                    })
                });
			},
			...mapActions(['getShopList', 'getPromotionDetail', 'savePromotion']),
		},
	}
</script>


// WEBPACK FOOTER //
// PromotionEditPage.vue?7d220e2d